import MobileTabsHeader from 'components/TabsHeader/MobileTabsHeader';
import TabsHeader from 'components/TabsHeader/TabsHeader';
import AirQuality from 'features/Weather/features/Forecast/features/AirQuality/index.web';
import Day15Forecast from 'features/Weather/features/Forecast/features/Day15Forecast/index.web';
import DetailedForecast from 'features/Weather/features/Forecast/features/DetailedForecast/index.web';
import ForecastHome from 'features/Weather/features/Forecast/features/ForecastHome/index.web';
import HourlyForecast from 'features/Weather/features/Forecast/features/HourlyForecast/index.web';
import { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import { capitalizeWord } from 'utils/strings/string.utils';
import { airQualitySubTabs, topTabs } from './config/forecastTabs.config';
import { daysOfWeek } from 'config/common.config';

export default function Forecast() {
  const [params, setParams] = useSearchParams();
  const [tab, setTab] = useState(params.get('tab')?.toLowerCase());
  const [day, setDay] = useState(
    params.get('day')?.toLowerCase() ?? daysOfWeek[new Date().getDay()].toLowerCase(),
  );
  const [subtab, setSubtab] = useState(params.get('subtab')?.toLowerCase());

  const renderAirQualityTab = () => {
    switch (subtab) {
      case 'air quality observations':
        return (
          <div className="d-flex flex-column w-100 h-100" id="air-quality-observations">
            <AirQuality />
          </div>
        );
      case 'air quality forecast':
        return (
          <div className="d-flex flex-column w-100 h-100" id="air-quality-forecast">
            <AirQuality />
          </div>
        );
      default:
        return (
          <div className="d-flex flex-column w-100 h-100" id="air-quality-observations">
            <AirQuality />
          </div>
        );
    }
  };

  const renderTab = () => {
    switch (params.get('tab')?.toLowerCase()) {
      case 'weather home':
        return (
          <div className="d-flex flex-column w-100 h-100" id="home">
            <ForecastHome />
          </div>
        );
      case 'hourly forecast':
        return (
          <div className="d-flex flex-column w-100 h-100" id="hourly">
            <HourlyForecast />
          </div>
        );
      case 'detailed forecast':
        return (
          <div className="d-flex flex-column w-100 h-100" id="detailed">
            <DetailedForecast selectedDay={capitalizeWord(day)} />
          </div>
        );
      case '15-day forecast':
        return (
          <div className="d-flex flex-column w-100 h-100" id="15-day">
            <Day15Forecast />
          </div>
        );
      case 'air quality':
        return renderAirQualityTab();
      default:
        return (
          <div className="d-flex flex-column w-100 h-100" id="home">
            <ForecastHome />
          </div>
        );
    }
  };

  useEffect(() => {
    const paramsObj = new URLSearchParams(params);
    const currentDay = daysOfWeek[new Date().getDay()];
    const tabParam = params.get('tab')?.toLowerCase();
    const dayParam = params.get('day')?.toLowerCase();
    const subtabParam = params.get('subtab')?.toLowerCase();

    setTab(tabParam);
    setDay(dayParam);
    setSubtab(subtabParam);

    if (tabParam === 'detailed forecast' && !dayParam) {
      paramsObj.set('day', currentDay);
    }

    if (!tabParam) {
      paramsObj.set('tab', 'Weather Home');
    }

    if (tabParam === 'air quality' && !subtabParam) {
      paramsObj.set('subtab', 'Air Quality Observations');
    }

    setParams(paramsObj);
  }, [params, setParams]);

  return (
    <Container fluid className="d-flex flex-column w-100 h-100 user-select-none pb-3">
      <div className="d-none d-lg-block flex-shrink-0">
        <TabsHeader
          borderRadius={
            tab === 'detailed forecast' || tab === 'air quality' ? '8px 8px 0 0' : '8px'
          }
          options={topTabs}
        />
        {tab === 'detailed forecast' && (
          <TabsHeader
            param="day"
            borderRadius={'0 0 8px 8px'}
            options={daysOfWeek.map((day) => ({ option: day }))}
            variant="primary"
          />
        )}
        {tab === 'air quality' && (
          <TabsHeader
            param="subtab"
            borderRadius={'0 0 8px 8px'}
            options={airQualitySubTabs}
            variant="primary"
          />
        )}
      </div>
      <div className="d-block d-lg-none flex-shrink-0">
        <MobileTabsHeader options={topTabs} />
        {tab === 'detailed forecast' && (
          <MobileTabsHeader param="day" options={daysOfWeek.map((day) => ({ option: day }))} />
        )}
        {tab === 'air quality' && (
          <MobileTabsHeader
            param="subtab"
            borderRadius={'0 0 8px 8px'}
            options={airQualitySubTabs}
            variant="primary"
          />
        )}
      </div>
      <Container fluid className="py-3 flex-grow-1 overflow-auto min-h-0">
        {renderTab()}
      </Container>
    </Container>
  );
}
